// Material helpers
import { createTheme, Theme } from '@mui/material';
import {CommonColors, Palette} from "@mui/material";
import palette from './palette';
import typography from './typography';
import overrides from './overrides';

export interface AppCommonColors extends CommonColors {
  muted: string,
  neutral: string,
}

export interface AppPalette extends Palette {
  common: AppCommonColors,
}

export interface AppTheme extends Theme {
  palette: AppPalette,
}

const theme = createTheme({
  palette,
  typography,
  components: overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
}) as AppTheme;

export default theme;
